import React from "react";
import ManagePricelistsContainer from "../../Containers/ManagePricelists";

const ManagePricelists = () => {
  return <ManagePricelistsContainer />;
};

export default ManagePricelists;
